//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// util
import { windowLocation } from "#webapp/src/util/location.util";
import { logger } from "#webapp/src/util/logger.util";
import { calculateBackoffTimeout } from "@clockwise/client-commons/src/util/network";
// other internals
import { constructionBlockSvg } from "#webapp/src/assets/img/illustrations";
import { asCard } from "#webapp/src/components/card";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { Button } from "@clockwise/design-system";
import { useSelector } from "react-redux";

//////////////////
// COMPONENT
//////////////////
const ChromeFatalErrorCmpt = () => {
  const networkFailureScale = useSelector((state: IReduxState) => state.shared.networkFailureScale);

  const reload = () => {
    logger.debug("reloading page after error timeout");
    windowLocation.reload("ChromeFatalError");
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => reload, calculateBackoffTimeout(networkFailureScale));

    return () => clearTimeout(timeout);
  }, [networkFailureScale]);

  return (
    <div>
      <div
        style={{ backgroundImage: `url("${constructionBlockSvg}")` }}
        className="cw-bg-brand-emphasis cw-bg-center cw-bg-[length:100px] cw-w-full cw-h-[120px] cw-p-2 cw-bg-no-repeat"
      ></div>
      <div className="cw-mx-2 cw-my-3 cw-space-y-4">
        <div className="cw-heading-lg">Oops! Something went wrong.</div>
        <div className="cw-body-base">
          We are having some technical difficulties. We will try again in a few moments or you may
          use the button below to reload Clockwise.
        </div>
        <Button variant="text" fullWidth onClick={reload}>
          Reload
        </Button>
      </div>
    </div>
  );
};

export const ChromeFatalError = asCard(ChromeFatalErrorCmpt);
